<div class="water-content-container">
    <div class="water-content-item-container">
        <div class="water-content-item-input-container">
            <mat-form-field appearance="outline" class="water-content-form-field">
                <mat-label>Water content at ambient temperature (23 &plusmn; 2&deg;C)</mat-label>
                <input matInput #waterContentAmbientTemperatureInput [(ngModel)]="waterContentAmbientTemperature"
                    class="water-content water-content-item-input"
                    (keyup.enter)="updateWaterContentAmbientTemperature($event)" (keyup.escape)="cancelUpdateWaterContentAmbientTemperature()"
                    (blur)="updateWaterContentAmbientTemperature($event)" />
                <mat-icon matSuffix (mousedown)="clearWaterContentAmbientTemperatureInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
    </div>
    <div class="water-content-item-container">
        <div class="water-content-item-input-container">
            <mat-form-field appearance="outline" class="water-content-form-field">
                <mat-label>If chemicals have been attached, entrapped or adsorbed to modify surface properties please indicate the water content before and after the modification</mat-label>
                <input matInput #waterContentInput [(ngModel)]="waterContent"
                    class="water-content water-content-item-input"
                    (keyup.enter)="updateWaterContent($event)" (keyup.escape)="cancelUpdateWaterContent()"
                    (blur)="updateWaterContent($event)" />
                <mat-icon matSuffix (mousedown)="clearWaterContentInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
    </div>
    <div class="water-content-item-container">
        <div class="water-content-item-input-container">
            <mat-form-field appearance="outline" class="water-content-form-field">
                <mat-label>Mean value &plusmn; standard deviation</mat-label>
                <input matInput #waterContentMeanValueStdDeviationInput [(ngModel)]="waterContentMeanValueStdDeviation"
                    class="water-content water-content-item-input"
                    (keyup.enter)="updateWaterContentMeanValueStdDeviation($event)" (keyup.escape)="cancelUpdateWaterContentMeanValueStdDeviation()"
                    (blur)="updateWaterContentMeanValueStdDeviation($event)" />
                <mat-icon matSuffix (mousedown)="clearWaterContentMeanValueStdDeviationInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
        <div class="input-error" *ngIf="hasFieldValidationError('waterContentMeanValueStdDeviation', 'required')">
            This is a required field.
        </div>
        <div class="input-error" *ngIf="!hasFieldValidationError('waterContentMeanValueStdDeviation', 'required') && hasFieldValidationError('waterContentMeanValueStdDeviation', 'pattern')">
            Invalid number entered.
        </div>
    </div>
    <div class="water-content-item-container">
        <div class="water-content-item-input-container">
            <mat-form-field appearance="outline" class="water-content-form-field">
                <mat-label>Number of measurements</mat-label>
                <input matInput #waterContentNumberOfMeasurementsInput [(ngModel)]="waterContentNumberOfMeasurements"
                    class="water-content water-content-item-input"
                    (keyup.enter)="updateWaterContentNumberOfMeasurements($event)" (keyup.escape)="cancelUpdateWaterContentNumberOfMeasurements()"
                    (blur)="updateWaterContentNumberOfMeasurements($event)" />
                <mat-icon matSuffix (mousedown)="clearWaterContentNumberOfMeasurementsInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
        <div class="input-error" *ngIf="hasFieldValidationError('waterContentNumberOfMeasurements', 'required')">
            This is a required field.
        </div>
        <div class="input-error" *ngIf="!hasFieldValidationError('waterContentNumberOfMeasurements', 'required') && hasFieldValidationError('waterContentNumberOfMeasurements', 'pattern')">
            Invalid number entered.
        </div>
    </div>
</div>